import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '@material/web/labs/navigationbar/navigation-bar.js';
import '@material/web/labs/navigationtab/navigation-tab.js';
import '@material/web/icon/icon.js';
import './MobileBottomNav.css';

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const navBarRef = useRef(null);

  const getActiveIndex = (pathname) => {
    if (pathname === '/' || pathname === '/home') return 0;
    if (pathname.startsWith('/search')) return 1;
    if (pathname.startsWith('/mylist')) return 2;
    if (pathname.startsWith('/profile')) return 3;
    return 0;
  };

  const activeIndex = getActiveIndex(location.pathname);

  useEffect(() => {
    const navBar = navBarRef.current;
    if (!navBar) return;

    navBar.activeIndex = activeIndex;

    const handleActivated = (e) => {
      const selectedIndex = e.detail?.index ?? navBar.activeIndex;
      switch (selectedIndex) {
        case 0:
          navigate('/');
          break;
        case 1:
          navigate('/search');
          break;
        case 2:
          navigate('/mylist');
          break;
        case 3:
          navigate('/profile');
          break;
        default:
          break;
      }
    };

    navBar.addEventListener('navigation-bar-activated', handleActivated);
    return () => {
      navBar.removeEventListener('navigation-bar-activated', handleActivated);
    };
  }, [activeIndex, navigate]);

  return (
    <nav className="mobile-bottom-nav" aria-label="Navigazione principale mobile">
      <md-navigation-bar ref={navBarRef} active-index={activeIndex}>
        <md-navigation-tab
          label="Home"
          active={activeIndex === 0 ? '' : undefined}
          aria-label="Home"
        >
          <md-icon slot="active-icon">
            <span className="material-symbols-rounded filled">home</span>
          </md-icon>
          <md-icon slot="inactive-icon">
            <span className="material-symbols-rounded">home</span>
          </md-icon>
        </md-navigation-tab>

        <md-navigation-tab
          label="Cerca"
          active={activeIndex === 1 ? '' : undefined}
          aria-label="Cerca"
        >
          <md-icon slot="active-icon">
            <span className="material-symbols-rounded filled">search</span>
          </md-icon>
          <md-icon slot="inactive-icon">
            <span className="material-symbols-rounded">search</span>
          </md-icon>
        </md-navigation-tab>

        <md-navigation-tab
          label="La mia lista"
          active={activeIndex === 2 ? '' : undefined}
          aria-label="La mia lista"
        >
          <md-icon slot="active-icon">
            <span className="material-symbols-rounded filled">video_library</span>
          </md-icon>
          <md-icon slot="inactive-icon">
            <span className="material-symbols-rounded">video_library</span>
          </md-icon>
        </md-navigation-tab>

        <md-navigation-tab
          label="Profilo"
          active={activeIndex === 3 ? '' : undefined}
          aria-label="Profilo"
        >
          <md-icon slot="active-icon">
            <span className="material-symbols-rounded filled">account_circle</span>
          </md-icon>
          <md-icon slot="inactive-icon">
            <span className="material-symbols-rounded">account_circle</span>
          </md-icon>
        </md-navigation-tab>
      </md-navigation-bar>
    </nav>
  );
}
